import React, { useContext, useState } from 'react';
import {
  Button, DialogBox, DialogBoxBody, DialogBoxHeader,
} from '@americanexpress/dls-react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import createSharedReactContext from 'create-shared-react-context';
import { DELETE_USER_SESSION_V1_URI, VirtualPaymentGlobalContext } from './utils/constants';

const GlobalContext = createSharedReactContext({}, VirtualPaymentGlobalContext);

const CancelButton = () => {
  const functionsApiUrl = useSelector((state) => state.getIn(['config', 'functionsApiUrl']));
  const messages = useIntl();
  const logOut = messages.formatMessage({ id: 'logOut' });
  const leaveText = messages.formatMessage({ id: 'leaveText' });
  const stayText = messages.formatMessage({ id: 'stayText' });
  const title = messages.formatMessage({ id: 'title' });
  const subTitle = messages.formatMessage({ id: 'subTitle' });

  const [dialogBoxState, setDialogBoxState] = useState(false);
  const { isLogOutDisabled } = useContext(GlobalContext);
  const dialogBoxOpen = () => setDialogBoxState(true);
  const closeDialogBox = () => setDialogBoxState(false);

  const inValidateSessionAndCloseWindow = async () => {
    const requestConfig = { credentials: 'include', method: 'GET', headers: { 'Content-Type': 'application/json' } };
    try {
      const response = await fetch(`${functionsApiUrl}${DELETE_USER_SESSION_V1_URI}`, requestConfig);
      if (!response.ok) {
        console.error(`Looks like there was a problem. Status Code : ${response.status}`);
      }
    } catch (err) {
      console.error(err);
    } finally {
      window.close();
    }
  };

  let modal = null;
  if (dialogBoxState) {
    modal = (
      <DialogBox id="dialog-box-example">
        <DialogBoxHeader id="dialog-box-header">
          <p>{title}</p>
        </DialogBoxHeader>
        <DialogBoxBody id="dialog-box-body">
          <p>
            {subTitle}
          </p>
          <Button
            styleType="primary"
            className="margin-auto-lr margin-1-b margin-3-t"
            theme={{
              display: 'block',
              width: '100%',
            }}
            onClick={inValidateSessionAndCloseWindow}
          >
            {leaveText}
          </Button>
          <Button
            id="dialog-box-stay"
            styleType="tertiary"
            className="margin-auto-lr"
            theme={{
              display: 'block',
              width: '100%',
            }}
            onClick={closeDialogBox}
          >
            {stayText}
          </Button>
        </DialogBoxBody>
      </DialogBox>
    );
  }
  return (
    <div>
      <Button
        className="margin-2-r"
        styleType="secondary"
        size="sm"
        aria-label="LogOut"
        onClick={dialogBoxOpen}
        disabled={isLogOutDisabled}
      >
        {logOut}
      </Button>
      {modal}
    </div>
  );
};

export default CancelButton;
